<template>
  <div>
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <div class="info-field">
          <q-icon name="groups" size="20px" color="primary" class="field-icon" />
          <span class="info-label">Задача:</span>
          <span class="info-value">{{ this.data?.task_name || '-' }}</span>
        </div>
      </div>
      <div class="form__item">
        <div class="info-field">
          <q-icon name="event" size="20px" color="primary" class="field-icon" />
          <span class="info-label">Дата:</span>
          <span class="info-value">{{ formatDate(this.data?.labor_date) }}</span>
        </div>
      </div>
      <!-- План (только для чтения) -->
      <div v-if="this.data?.plan_people !== null && this.data?.plan_people !== undefined" class="form__item">
        <div class="info-field readonly-field">
          <q-icon name="calendar_today" size="18px" color="grey-7" class="field-icon" />
          <span class="info-label">План (люди):</span>
          <span class="info-value">{{ this.data?.plan_people || '0' }}</span>
        </div>
      </div>
      <!-- Факт (редактируемое) -->
      <div class="form__item">
        <CustomInput
          label="Факт (кол-во людей)"
          type="number"
          :value="this.formData.fact_people"
          @change_input="(value) => onChange('fact_people', value)"
          placeholder="Фактическое количество"
          class="fact-input"
        />
      </div>
      <div class="form__footer">
        <div v-if="this.data?.labor_plan_fact_id && this.data?.fact_people" class="delete-btn-container">
          <q-btn
            label="Очистить факт"
            color="negative"
            outline
            :loading="this.loading"
            @click="onDelete"
            class="delete-btn"
          />
        </div>
        <CustomModalFooter :btn-loading="this.loading" />
      </div>
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "edit-labor-fact",
  components: { CustomInput, CustomModalFooter },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        fact_people: this.data?.fact_people || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    formatDate(date) {
      if (!date) return '-';
      // Преобразуем YYYY-MM-DD в DD.MM.YYYY
      const parts = date.split('-');
      if (parts.length === 3) {
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
      }
      return date;
    },
    async onSubmit() {
      this.loading = true
      
      const submitData = {
        labor_plan_fact_id: this.data?.labor_plan_fact_id || null,
        work_group_id: this.data?.work_group_id,
        labor_date: this.data?.labor_date,
        plan_people: this.data?.plan_people || null, // Сохраняем существующий план
        fact_people: this.formData.fact_people || null,
      }
      
      await this.data?.onSubmit(submitData)
      this.loading = false
    },
    async onDelete() {
      this.loading = true
      
      // Обнуляем только факт, оставляем план
      const submitData = {
        labor_plan_fact_id: this.data?.labor_plan_fact_id || null,
        work_group_id: this.data?.work_group_id,
        labor_date: this.data?.labor_date,
        plan_people: this.data?.plan_people || null, // Сохраняем план
        fact_people: null, // Обнуляем факт
      }
      
      await this.data?.onSubmit(submitData)
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 320px;
  gap: 8px;
  margin-top: 5px;

  @media (max-width: 428px) {
    width: 100%;
  }
}

.form__item {
  margin-bottom: 0;
}

.info-field {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 13px;
  
  .field-icon {
    flex-shrink: 0;
  }
  
  .info-label {
    font-weight: 600;
    min-width: 110px;
    color: #666;
  }
  
  .info-value {
    color: #333;
    font-size: 13px;
  }
  
  &.readonly-field {
    background-color: #f5f5f5;
    padding: 8px;
    border-radius: 4px;
  }
}

.fact-input {
  width: 100%;
  
  :deep(input) {
    text-align: center;
  }
}

.form__footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.delete-btn-container {
  display: flex;
  justify-content: flex-start;
  padding-top: 6px;
  border-top: 1px solid #e0e0e0;
}

.delete-btn {
  min-width: 100px;
}
</style>

